import { action, computed, observable } from "mobx";
import enUS from "antd/es/locale/en_US";
import zhCN from "antd/es/locale/zh_CN";
import zhTW from "antd/es/locale/zh_TW";
import hi_IN from "antd/es/locale/hi_IN";
import id_ID from "antd/es/locale/id_ID";
import ja_JP from "antd/es/locale/ja_JP";
import ko_KR from "antd/es/locale/ko_KR";
import ms_MY from "antd/es/locale/ms_MY";
import th_TH from "antd/es/locale/th_TH";
import vi_VN from "antd/es/locale/vi_VN";
import moment from "moment";
import "moment/locale/zh-cn";
import "moment/locale/en-au";
import "moment/locale/zh-tw";
import "moment/locale/hi";
import "moment/locale/id";
import "moment/locale/ja";
import "moment/locale/ko";
import "moment/locale/ms";
import "moment/locale/th";
import "moment/locale/vi";
import http, { getQuery } from "../service/http";
import "../locales";

class Store {
  /**用户信息 */
  @observable member = null;
  /**定位坐标 */
  @observable position = null;
  /**定位token */
  @observable private_token = undefined;
  /**
   * 默认从 URL 中获取 private_token
   * 如果URL没有 从当前的域名的主域名获取 private_token
   *
   * 如果当前域名是 website.diningcity.cn/xxx
   * www.diningcity.cn/api/v2/members/profile?callback=JSONP_CALLBACK
   *
   * website.diningcity.hk/xxx
   * www.diningcity.hk/api/v2/members/profile?callback=JSONP_CALLBACK
   *
   * website.diningcity.sg/xxx
   * www.diningcity.sg/api/v2/members/profile?callback=JSONP_CALLBACK
   *
   * @memberof Service
   */
  get jsonCallback() {
    let host = "";
    switch (document.domain) {
      case "website.diningcity.cn":
        host = "https://dcwebsiteapi.diningcity.cn";
        break;
      case "website.diningcity.hk":
        host = "https://dcwebsiteapi.diningcity.hk";
        break;
      case "website.diningcity.sg":
        host = "https://dcwebsiteapi.diningcity.sg";
        break;

      default:
        host = "https://dcwebsiteapi.diningcity.cn";
        break;
    }
    return host + "/api/v2/members/profile?callback=JSONP_CALLBACK";
  }
  /**
   * 通过token获取用户信息
   *
   * @param {string} private_token
   * @returns
   * @memberof Service
   */
  getUserByToken(private_token) {
    return new Promise((resolve, reject) => {
      http
        .get("/member", {
          headers: {
            "access-token-member": private_token,
          },
        })
        .then(({ data }) => {
          this.member = data;
          resolve(data);
        })
        .catch((error) => {
          console.error("获取用户信息失败, ", error);
          reject(error);
        });
    });
  }

  /**
   * 获取用户信息
   *
   * @returns
   * @memberof Service
   */
  @action
  async show() {
    let member = {};
    if (this.member) return this.member;
    try {
      let { private_token } = getQuery();
      if (private_token) {
        member = await this.getUserByToken(private_token);
        this.member = member;
        window.private_token = member.private_token;
        this.private_token = member.private_token;
        return member;
      } else {
        this.member = null;
        this.private_token = ''
        window.private_token = ''
        let data = await http.jsonp(this.jsonCallback, { timeout: 3000 });
        member = data.member;
        this.member = member;
        window.private_token = member.private_token;
        this.private_token = member.private_token;
      }
    } catch (error) {
      console.error("获取用户信息失败, ", error);
      return Promise.reject(error);
    }
  }
  /**获取距离 */
  @action getDistance(lat2, lng2) {
    if (this.position) {
      const { lat, lng } = this.position;
      let distance = L.latLng(lat, lng).distanceTo(L.latLng(lat2, lng2));
      return distance > 1000
        ? `${(distance / 1000).toFixed(1)}km`
        : `${Math.ceil(distance)}m`;
    }
  }

  @action getLocale() {
    let query = http.getQuery();
    let { lang = "en" } = query;
    const languages = {
      en: {
        moment: "en-au",
        antd: enUS,
      },
      hi: {
        moment: "hi",
        antd: hi_IN,
      },
      id: {
        moment: "id",
        antd: id_ID,
      },
      ja: {
        moment: "ja",
        antd: ja_JP,
      },
      ko: {
        moment: "ko",
        antd: ko_KR,
      },
      ms: {
        moment: "ms",
        antd: ms_MY,
      },
      th: {
        moment: "th",
        antd: th_TH,
      },
      vi: {
        moment: "vi",
        antd: vi_VN,
      },
      zh: {
        moment: "zh-cn",
        antd: zhCN,
      },
      "zh-HK": {
        moment: "zh-tw",
        antd: zhTW,
      },
    };
    const language = languages[lang] || languages['en']
    moment.locale(language.moment);
    return language.antd;
  }
}

export default new Store();
